import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminGuard } from './guards/admin.guard';
import { AppAccessAuthGuard } from './guards/app-access-auth.guard';
import { ComponentCanDeactivateGuard } from './guards/component-can-deactivate.guard';
import { InternalUserGuard } from './guards/internal-user.guard';
import { SplitGuard } from './guards/split.guard';
import { BatchComponent } from './pages/batch/batch.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { FilesComponent } from './pages/files/files.component';
import { HomeComponent } from './pages/home/home.component';
import { LineItemListComponent } from './pages/line-item-list/line-item-list.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { CccReportComponent } from './pages/reports/ccc-report/ccc-report.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { SearchXrefComponent } from './pages/search-xref/search-xref.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { MyRequestsComponent } from './pages/requests/my-requests/my-requests.component';
import { XrefListComponent } from './pages/requests/xref-list/xref-list.component';

enum PathStrings {
  REQUEST_XREF_LIST = 'xrefList/:rfxHeaderKey',
}

interface RouteParams {
  search: string;
  replacement: string;
}
export class RouteManager {
  public static requestPathFormat(requestId: number) {
    return RouteManager.format(PathStrings.REQUEST_XREF_LIST, {
      search: ':rfxHeaderKey',
      replacement: `${requestId}`,
    });
  }

  private static format(
    path: PathStrings,
    pathParams: RouteParams[] | RouteParams,
  ) {
    let modifiedPath: string = path;
    const pathParamsConsolidated = Array.isArray(pathParams)
      ? pathParams
      : [pathParams];

    pathParamsConsolidated.forEach(({ search, replacement }) => {
      modifiedPath = path.replace(search, replacement);
    });
    return '/' + modifiedPath;
  }
}

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'search',
    component: SearchXrefComponent,
    canActivate: [AppAccessAuthGuard],
    canDeactivate: [ComponentCanDeactivateGuard],
  },
  {
    path: 'reports/:id',
    component: ReportsComponent,
    canActivate: [AppAccessAuthGuard],
  },
  {
    path: 'cccReport',
    component: CccReportComponent,
    canActivate: [AppAccessAuthGuard],
  },
  {
    path: 'batch',
    component: BatchComponent,
    canActivate: [AppAccessAuthGuard, InternalUserGuard],
  },
  {
    path: 'files',
    component: FilesComponent,
    canActivate: [AppAccessAuthGuard],
  },
  {
    path: 'lineitemlist',
    component: LineItemListComponent,
    canActivate: [AppAccessAuthGuard],
  },
  {
    path: 'request',
    component: MyRequestsComponent,
    canActivate: [AppAccessAuthGuard, SplitGuard],
    data: { splitName: 'Request_Nav_Tab' },
  },
  {
    path: PathStrings.REQUEST_XREF_LIST,
    component: XrefListComponent,
    canActivate: [AppAccessAuthGuard],
  },
  { path: 'callback', component: CallbackComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'differingunspsc',
    component: SearchXrefComponent,
    canActivate: [AppAccessAuthGuard, AdminGuard],
    canDeactivate: [ComponentCanDeactivateGuard],
  },

  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
